import _ from 'lodash';
import { SearchStringSchema } from '../common/schemas';
import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn, createTransformer } from '../common/utils';
import { LeadAttributes } from './constants';
import { DBLeadSchema, LeadSchema } from './schemas';

export const LeadCodecConfig: TransformerConfig<typeof LeadSchema, typeof DBLeadSchema> = {
  name: 'Lead',
  clientSchema: LeadSchema,
  dbSchema: DBLeadSchema,
  transformers: [
    // Handle search string updates
    createTransformer<typeof LeadSchema, typeof DBLeadSchema>({
      encoder: {
        sourceFields: LeadAttributes.Search,
        // No dependencies needed as they may be undefined
        // dependencies: LeadAttributes.Search,
        encode: (lead, oldLead) => {
          let searchStr = '';
          LeadAttributes.Search.forEach(attr => {
            const val = lead?.[attr] ?? oldLead?.[attr] ?? '';
            searchStr += SearchStringSchema.parse(val);
          });
          return { searchStr, ..._.pick(lead, LeadAttributes.Search) };
        },
      },
    }),
  ],
};

export const encodeLeadToDb = createEncodeToDbFn(LeadCodecConfig);
export const decodeLeadFromDb = createDecodeFromDbFn(LeadCodecConfig);
